import { observer } from "mobx-react"
import { userState } from "./UserState"
import { useEffect } from "react"
import { Button, Form, Input, Upload, Skeleton, Select } from "antd"
import ImageUploader from "../../share/misc/ImageUploader"

const User = ()=>{
    useEffect(()=>{
        userState.gettingUserInfo();
    },[])
    const [userForm] = Form.useForm();
    useEffect(()=>{
        userForm.setFieldsValue({
            username: userState.userInfo.username,
            full_name: userState.userInfo.full_name,
            location: userState.userInfo.location,
            phone_number: userState.userInfo.phone_number,
            email: userState.userInfo.email,
            gender: userState.userInfo.gender,
        })
    },[userState.userInfo.username, userState.userInfo.full_name, userState.userInfo.location, userState.userInfo.phone_number, userState.userInfo.email, userState.userInfo.gender])
    return(
    <div className="user container mx-auto flex gap-5 justify-center">
        {userState.loadingDataStatus ?<Skeleton.Avatar active={true}></Skeleton.Avatar> :
        <div className="flex flex-col justify-center items-center border-r border-red-50 pr-5">
            <ImageUploader removeAction={()=>{userState.userInfo.img = ''}} src={userState.userInfo.img} onFileChange={(event)=>{userState.handleCreateTemporaryImg(event)}}/>
            <div>Dụng lượng file tối đa 1 MB</div>
            <div>Định dạng:.JPEG, .PNG</div>
        </div>
        }
        <Form form={userForm} layout="vertical" className="min-w-96"
        onFinish={(values)=>{
            userState.updatingUserInfo(values);
        }}>
            <Form.Item wrapperCol={{span: 24}} labelCol={{span: 24}} name={'username'} label="Tên người dùng" rules={[{required: true, message: 'Vui lòng điền Tên người dùng'}]}>
                {userState.loadingDataStatus ? (<Skeleton.Input active={true}></Skeleton.Input>):(<><Input/></>)}
            </Form.Item>
            <Form.Item wrapperCol={{span: 24}} labelCol={{span: 24}} name={'full_name'} label="Họ và tên" rules={[{required: true, message: 'Vui lòng điền Họ và tên'}]}>
                {userState.loadingDataStatus ? (<Skeleton.Input active={true}></Skeleton.Input>):(<><Input/></>)}
            </Form.Item>
            <Form.Item wrapperCol={{span: 24}} labelCol={{span: 24}} name={'gender'} label="Tên người dùng" rules={[{required: true, message: 'Vui lòng điền Tên người dùng'}]}>
                {userState.loadingDataStatus ? (<Skeleton.Input active={true}></Skeleton.Input>):(<><Select options={[{value: 1, label: "Nam"}, {value: 0, label: "Nữ"}, {value: -1, label: "Khác"}]}/></>)}
            </Form.Item>
            <Form.Item wrapperCol={{span: 24}} labelCol={{span: 24}} name={'location'} label="Địa chỉ" rules={[{required: true, message: 'Vui lòng điền Địa chỉ'}]}>
                {userState.loadingDataStatus ? (<Skeleton.Input active={true}></Skeleton.Input>):(<><Input/></>)}
            </Form.Item>
            <Form.Item wrapperCol={{span: 24}} labelCol={{span: 24}} name={'phone_number'} label="Số điện thoại" rules={[{required: true, message: 'Vui lòng điền Số điện thoại'}]}>
                {userState.loadingDataStatus ? (<Skeleton.Input active={true}></Skeleton.Input>):(<><Input/></>)}
            </Form.Item>
            <Form.Item wrapperCol={{span: 24}} labelCol={{span: 24}} name={'email'} label="Email" rules={[{required: true, message: 'Vui lòng điền Email'}]}>
                {userState.loadingDataStatus ? (<Skeleton.Input active={true}></Skeleton.Input>):(<><Input/></>)}
            </Form.Item>
            <Button htmlType="submit" type="primary" danger loading={userState.updatingStatus}>Lưu</Button>
        </Form>
    </div>)
}
export default observer(User)